import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { discountsApi, type DiscountListParams } from '../api/discounts-api';

import { discountKeys } from './discount-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function discountListQueryOptions(storeId: string, params: DiscountListParams) {
  return queryOptions({
    queryKey: discountKeys.list(storeId, params),
    queryFn: () => discountsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useDiscounts(storeId: string, params: DiscountListParams) {
  return useQuery(discountListQueryOptions(storeId, params));
}
